import React, { useState } from "react";
import FAQ from '.././component/Utilities';
import '.././css/faq.css'
import Navigation from "../component/Navigation";
import PriceCard from "../component/PriceCard";


function FAQPage() {
  document.title = 'FAQ?'
    const [faqs, setfaqs] = useState([
        {
          question: 'Hvor kører jeres server henne?',
          answer: 'Alle vores servere køre i Falkenstein i Tyskland.',
          open: false
        },
        {
          question: 'Har i stabile priser?',
          answer: 'Det kan du tro vi har fucking stabile priser',
          open: false
        },
        {
          question: 'Hvad er managed hosting?',
          answer: 'Managed hosting er hvor du som kunde betaler et lidt højere gebyr for tilgengæld at have udvidet support adgang. Dette gør at vi går den ekstra meter for at finde en løsning til dig og sikrer at du altid får hurtigt svar. \n Denne løsning er ideel hvis du er ny til spil servere eller har behov for hjælp til det tekniske bag. \n Er du i tvivl om denne løsning er noget for dig kan du kontakte os via følgende link: {indsæt link her}',
          open: false
        },
        {
          question: 'Kan i jeres shit???',
          answer: 'Vi kan mega meget vores shit.',
          open: false
        }
      ]);
    
      const toggleFAQ = index => {
        setfaqs(faqs.map((faq, i) => {
          if (i === index) {
            faq.open = !faq.open
          } else {
            faq.open = false;
          }
    
          return faq;
        }))
      }
    
    
      return (
        <div className="App">
          <Navigation />
          <div className="faqs">
            {faqs.map((faq, i) => (
              <FAQ faq={faq} index={i} toggleFAQ={toggleFAQ} />
            ))}
          </div>
          <div>
            <PriceCard />
          </div>
        </div>
      );
    }

export default FAQPage;
